<template>
  <div style="display: flex;">
    <ImgView :src="houseFrom.img" />
    <div>
      <div>
        <el-form ref="form" :model="houseFrom" label-width="120px">
          <el-form-item label="实名：" style="margin-bottom: 0px;">
<!--            <span>{{houseFrom.identityAuth.overallAuthState==2?houseFrom.identityAuth.identityName:''}}</span>-->
            {{ houseFrom.identityAuth.identityState == 2?houseFrom.identityAuth.identityName:houseFrom.identityAuth.zhimaState == 1?houseFrom.identityAuth.zhimaCertName + ' (芝麻)':houseFrom.identityAuth.baiduState == 1?houseFrom.identityAuth.baiduCertName + ' (百度)':'' }}
          </el-form-item>
          <el-form-item label="房产城市：" style="margin-bottom: 8px;">
            <span>{{houseFrom.addr}}</span>
          </el-form-item>
          <el-form-item label="审核结果：">
            <el-radio-group v-model="state">
              <el-radio-button :label="2">通过 <i class="el-icon-check" v-show="state==2"></i></el-radio-button>
              <el-radio-button :label="3">不通过 <i class="el-icon-check" v-show="state==3"></i></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="不通过原因：" v-show="state==3">
            <el-input type="textarea" v-model="houseFrom.remark" placeholder="不通过原因仅用户可见" style="width:28em;margin-bottom: 8px;"></el-input>
            <el-radio-group v-model="msg" @change="msgChange">
              <el-radio :label="'请上传房产证或购房证明等真实有效的材料。'">请上传房产证或购房证明等真实有效的材料</el-radio>
              <el-radio :label="'身份证未认证成功。请先完善身份证资料，再上传认证材料。'">身份证未认证成功。请先完善身份证资料，再上传认证材料</el-radio>
              <el-radio :label="'该材料显示的名字，与用户实名不一致，请重新上传材料。'">该材料显示的名字，与用户实名不一致，请重新上传材料</el-radio>
              <el-radio :label="'材料过于模糊，无法审核。请重新上传清晰材料。'">材料过于模糊，无法审核。请重新上传清晰材料</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="材料类型：">
            <el-radio-group v-model="authType" style="line-height:18px;padding-top:3px;">
              <el-radio :label="0">其他材料</el-radio>
              <el-radio :label="1">房产证</el-radio>
              <el-radio :label="2">购房证明</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer" style="text-align: center">
        <el-button size="medium" @click="cancel">返 回</el-button>
        <el-button type="primary"  @click="submit" v-loading="submitLoading">提 交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateAuthHouse } from '@/api/url'
import { postFormData } from '@/api/api'
import ImgView from "@/views/auth/components/ImgView";
export default {
  name: "JobDialog",
  components: { ImgView },
  props: {
    value: Object
  },
  data() {
    return {
      houseFrom: this.value.houseFrom,
      authType: this.value.houseFrom.authType?this.value.houseFrom.authType:0,
      submitLoading: false,
      state: 2,
      msg: ''
    }
  },
  methods: {

    //返回
    cancel() {
      // this.houseFrom = this.value.houseFrom,
      this.$emit('close');
    },

    msgChange(){
      this.houseFrom.remark = this.msg;
    },

    //提交
    submit() {
      if(this.state == 3 && !this.houseFrom.remark){
        this.$message({
          showClose: true,
          duration: 1500,
          message: '不通过原因不能为空',
          type: 'warning'
        })
        return;
      }
      this.$confirm(this.state == 2?'确定要给予【'+this.houseFrom.nickName+'】通过吗？':this.state == 3?'确定要给予【'+this.houseFrom.nickName+'】不通过吗？':'').then(() => {
        this.submitLoading = true;
        let _this = this;
        let param = {};
        param['id'] = this.houseFrom.id;
        param['userId'] = this.houseFrom.userId;
        param['schoolName'] = this.houseFrom.schoolName;
        param['state'] = this.state;
        param['authType'] = this.authType;
        param['remark'] = this.state == 3?this.houseFrom.remark:'';
        postFormData(updateAuthHouse,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
            _this.$emit('close');
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.submitLoading = false;
        })
            .catch(function(response){
              _this.submitLoading = false;
            })
      })
          .catch(() => {})
    }
  },
  watch: {

  },
  mounted() {

  },
  created() {
  }

}
</script>

<style>

</style>
